import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import ReactMarkdown from 'react-markdown';
import IndustryExpertiseThread from './Sidebar/IndustryExpertiseThread';
import ProspectingOutputThread from './Sidebar/ProspectingOutputThread';
import PrepThread from './Sidebar/PrepFormThread';
import PostCallThread from './Sidebar/PostCallFormThread';
import HomeChatThread from './Sidebar/HomeChatThread';

const ThreadViewer = () => {
  const { threadId } = useParams();
  const [threadData, setThreadData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    const fetchThread = async () => {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) return;

      const docRef = doc(db, 'users', user.uid, 'threads', threadId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setThreadData(docSnap.data());
        setActiveId(threadId); // ✅ Store the current id so we know it's in sync
      } else {
        setThreadData(null);
        setActiveId(null);
      }

      setLoading(false);
    };

    fetchThread();
  }, [threadId]);

  if (loading) return <div style={{ padding: '40px' }}>⏳ Loading thread...</div>;
  if (!threadData || threadId !== activeId) {
    return <div style={{ padding: '40px' }}>⏳ Loading correct thread...</div>;
  }

  switch (threadData?.type) {
    case 'home':
      return <HomeChatThread key={threadId} thread={threadData} />;
    case 'industry':
      return <IndustryExpertiseThread key={threadId} thread={threadData} />;
    case 'prospecting':
      return <ProspectingOutputThread key={threadId} thread={threadData} />;
    case 'prep':
      return <PrepThread key={threadId} thread={threadData} />;
    case 'postcall':
      return <PostCallThread key={threadId} thread={threadData} />;
    default:
      return (
        <div style={{ padding: '40px', maxWidth: '960px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '28px', fontWeight: 'bold' }}>
            {threadData.name || `Thread: ${threadId}`}
          </h2>
          <p style={{ color: 'red' }}>⚠️ Unknown or missing thread type: {threadData?.type || 'undefined'}</p>
          <div style={{ marginTop: '24px' }}>
            {threadData.chat?.map((item, index) => (
              <div key={index} style={{ marginBottom: '20px' }}>
                <strong>{item.role === 'user' ? '🧑 You' : '🤖 Alfred'}</strong>
                <div style={{ background: '#f3f4f6', padding: '12px', borderRadius: '10px', marginTop: '6px' }}>
                  <ReactMarkdown>{item.content}</ReactMarkdown>
                </div>
              </div>
            ))}
          </div>
        </div>
      );
  }
};

export default ThreadViewer;
